module.exports = __webpack_public_path__ + "static/img/ghasforing-logo.890c900.png";